import { render, staticRenderFns } from "./supportModal.html?vue&type=template&id=6fef78b4&"
import script from "./supportModal.vue?vue&type=script&lang=js&"
export * from "./supportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports